// extracted by mini-css-extract-plugin
export default {"alignRight":"alignRight__NTZhY","alignCenter":"alignCenter__NTBlM"};